import React from 'react';

import cn from 'classnames';

import { formatMessageDate } from '@entities/message/lib';
import { Chip } from '@shared/ui';

import cls from './DateChip.module.css';

interface IDateChipProps {
    datetime: string;
    className?: string;
}

export const DateChip = ({ datetime, className }: IDateChipProps) => {
    const formattedDate = formatMessageDate(datetime, 'DD MMMM');

    return (
        <Chip
            containerStyles={cn(cls.DateChipContainer, className)}
            textStyles={cls.DateChipText}
            textContent={formattedDate}
        />
    );
};
